// src/pages/Financas/Financas.js
import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, where, orderBy, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebaseConfig'; // Caminho para seu firebaseConfig.js
import { Link } from 'react-router-dom';
import GastoForm from './GastoForm'; // Importa o formulário de gasto
import './Financas.css'; // Estilos para esta página

function Financas() {
  const [gastos, setGastos] = useState([]);
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');

  // A função buscarDadosFinanceiros permanece a mesma, pois já busca os dados corretamente.
  const buscarDadosFinanceiros = async () => {
    setLoading(true);
    setError(null);
    try {
      // --- Buscar Gastos ---
      let qGastos = collection(db, "gastos");
      if (dataInicio && dataFim) {
        const start = new Date(dataInicio);
        const end = new Date(dataFim);
        end.setHours(23, 59, 59, 999);
        qGastos = query(qGastos, where("data", ">=", start), where("data", "<=", end), orderBy("data", "desc"));
      } else {
         qGastos = query(qGastos, orderBy("data", "desc"));
      }
      const querySnapshotGastos = await getDocs(qGastos);
      const gastosDoFirestore = querySnapshotGastos.docs.map(doc => ({ id: doc.id, ...doc.data(), data: doc.data().data.toDate() }));
      setGastos(gastosDoFirestore);

      // --- Buscar Vendas ---
      let qVendas = collection(db, "vendas");
      if (dataInicio && dataFim) {
        const start = new Date(dataInicio);
        const end = new Date(dataFim);
        end.setHours(23, 59, 59, 999);
        qVendas = query(qVendas, where("dataHora", ">=", start), where("dataHora", "<=", end), orderBy("dataHora", "desc"));
      } else {
         qVendas = query(qVendas, orderBy("dataHora", "desc"));
      }
      const querySnapshotVendas = await getDocs(qVendas);
      const vendasDoFirestore = querySnapshotVendas.docs.map(doc => ({ id: doc.id, ...doc.data(), dataHora: doc.data().dataHora.toDate() }));
      setVendas(vendasDoFirestore);

    } catch (err) {
      console.error("Erro ao buscar dados financeiros:", err);
      setError("Erro ao carregar dados financeiros. Verifique sua conexão ou configurações do Firebase.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarDadosFinanceiros();
  }, [dataInicio, dataFim]);

  const handleAdicionarGasto = async (novoGasto) => {
    try {
      await addDoc(collection(db, "gastos"), {
        ...novoGasto,
        timestampRegistro: serverTimestamp(),
      });
      alert('Gasto registrado com sucesso!');
      buscarDadosFinanceiros();
    } catch (e) {
      console.error("Erro ao adicionar gasto: ", e);
      alert('Erro ao registrar gasto. Tente novamente.');
    }
  };

  // --- ALTERAÇÃO APLICADA ---
  // Esta função agora calcula o total de vendas de forma segura,
  // somando os subtotais de cada item dentro de cada venda.
  const calcularTotalVendasSeguro = () => {
    return vendas.reduce((totalGeral, venda) => {
      // Para cada venda, calcula seu total somando o subtotal de seus itens
      const totalDaVendaRecalculado = venda.itens.reduce((subtotalVenda, item) => {
        // item.subtotal é a fonte confiável (preço * quantidade)
        return subtotalVenda + item.subtotal;
      }, 0);
      return totalGeral + totalDaVendaRecalculado;
    }, 0);
  };

  const calcularTotalGastos = () => {
    return gastos.reduce((total, gasto) => total + gasto.valor, 0);
  };

  // --- ALTERAÇÃO APLICADA ---
  // Esta função agora usa o cálculo seguro de vendas para determinar o lucro.
  const calcularLucroPrejuizo = () => {
    return calcularTotalVendasSeguro() - calcularTotalGastos();
  };

  return (
    <div className="financas-container">
      <h2>Dashboard Financeiro</h2>
      <div className="financas-nav-links">
        <Link to="/pdv" className="voltar-btn">← Voltar para o PDV</Link>
        <Link to="/historico" className="voltar-btn">Ver Histórico →</Link>
        <Link to="/admin/produtos" className="voltar-btn">Gerenciar Produtos →</Link>
      </div>

      <GastoForm onAdicionarGasto={handleAdicionarGasto} />

      <div className="relatorio-section">
        <h3>Relatório de Lucro/Prejuízo</h3>

        <div className="filtro-datas">
          <label>De:</label>
          <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
          <label>Até:</label>
          <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
        </div>

        {loading && <p>Carregando dados financeiros...</p>}
        {error && <p className="erro-mensagem">{error}</p>}

        {!loading && !error && (
          <div className="resumo-financeiro">
            {/* --- ALTERAÇÃO APLICADA --- */}
            {/* O texto foi alterado para "Total de Vendas (Verificado)" e chama a nova função segura */}
            <p>Total de Vendas (Verificado): <span className="valor-vendas">R$ {calcularTotalVendasSeguro().toFixed(2)}</span></p>
            <p>Total de Gastos: <span className="valor-gastos">R$ {calcularTotalGastos().toFixed(2)}</span></p>
            <p>Lucro/Prejuízo: <span className={calcularLucroPrejuizo() >= 0 ? 'valor-lucro' : 'valor-prejuizo'}>
              R$ {calcularLucroPrejuizo().toFixed(2)}
            </span></p>
          </div>
        )}

        <div className="detalhes-tabelas">
            <div className="tabela-gastos">
                <h4>Gastos Registrados</h4>
                {gastos.length === 0 ? (
                    <p>Nenhum gasto encontrado para o período.</p>
                ) : (
                    <table className="dados-table">
                        {/* O conteúdo da tabela de gastos permanece o mesmo */}
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Descrição</th>
                                <th>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastos.map(gasto => (
                                <tr key={gasto.id}>
                                    <td>{gasto.data ? gasto.data.toLocaleDateString('pt-BR') : 'N/A'}</td>
                                    <td>{gasto.descricao}</td>
                                    <td>R$ {gasto.valor.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <div className="tabela-vendas-detalhe">
                <h4>Vendas Detalhadas</h4>
                 {vendas.length === 0 ? (
                    <p>Nenhuma venda encontrada para o período.</p>
                ) : (
                    <table className="dados-table">
                         {/* O conteúdo da tabela de vendas permanece o mesmo */}
                        <thead>
                            <tr>
                                <th>Data/Hora</th>
                                <th>Itens</th>
                                <th>Total (Registrado)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendas.map(venda => (
                                <tr key={venda.id}>
                                    <td>{venda.dataHora ? venda.dataHora.toLocaleString('pt-BR') : 'N/A'}</td>
                                    <td>
                                        <ul>
                                            {venda.itens.map((item, idx) => (
                                                <li key={idx}>
                                                    {item.quantidade}x {item.nome} {item.tamanho ? `(${item.tamanho})` : ''} - R$ {item.subtotal.toFixed(2)}
                                                </li>
                                            ))}
                                        </ul>
                                    </td>
                                    <td>R$ {venda.valorTotalVenda.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
      </div>
    </div>
  );
}

export default Financas;